export const GET_ALL_PENALTY_TARIFF = "GET_ALL_PENALTY_TARIFF"
export const CREATE_PENALTY_TARIFF = "CREATE_PENALTY_TARIFF"
export const UPDATE_PENALTY_TARIFF = "UPDATE_PENALTY_TARIFF"
export const DELETE_PENALTY_TARIFF = "DELETE_PENALTY_TARIFF"
